import { cilEnvelopeClosed, cilMenu, cilMoon, cilSun, cilUser } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import { CButton } from '@coreui/react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useDrawer } from 'src/providers/DrawerProvider';
import { useAppState } from 'src/providers/StateProvider';
import LanguageChanger from './LanguageChanger';
import React from 'react';
import { useUser } from 'src/providers/User';
import { logout } from 'src/common';
import { SERVER_API } from 'src/config';
import blankAvatar from 'src/assets/images/blank.svg';
import { useTheme } from 'src/providers/Theme';

export function FooterMenu() {
  const drawer = useDrawer();
  const appState = useAppState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const { theme, setTheme } = useTheme();

  const getMenuContent = () => {
    return (
      <div className='p-3 d-flex flex-column gap-3'>
        <a href='#/models' onClick={() => drawer.close()}>
          {t('3dmodels')}
        </a>
        <a href='#/subscriptions' onClick={() => drawer.close()}>
          {t('subscriptions')}
        </a>
        <a href='#/admin' onClick={() => drawer.close()}>
          {t('adminpanel')}
        </a>
        <span>
          <LanguageChanger />
        </span>
      </div>
    );
  };

  const getFiltersContent = () => {
    return (
      <div className='p-3'>
        <h5>Filters Content</h5>
        <p>This is the content inside the drawer filters.</p>
        <CButton color='primary' onClick={() => drawer.close()}>
          Close Filters
        </CButton>
      </div>
    );
  };

  const getPaymentsContent = () => {
    return (
      <div className='p-3'>
        <h5>Payments Content</h5>
        <p>This is the content inside the drawer payments.</p>
        <CButton color='primary' onClick={() => drawer.close()}>
          Close Payments
        </CButton>
      </div>
    );
  };

  const getAccountContent = () => {
    return (
      <div className='p-3 d-flex flex-column gap-3'>
        <img
          src={user.avatar ? SERVER_API + 'upload/avatars/' + user.avatar : blankAvatar}
          alt='avatar'
          className='align-self-center'
          style={{ width: '80px', height: '80px', borderRadius: '50%' }}
        />
        <h5>{user?.username}</h5>
        <a href='/#/profile' onClick={() => drawer.close()}>
          {t('profile')}
        </a>
        <a href='/#/bills' onClick={() => drawer.close()}>
          {t('bills')}
        </a>
        <a href='/#/subscriptions' onClick={() => drawer.close()}>
          {t('subscriptions')}
        </a>
        <a href='/#/tickets' onClick={() => drawer.close()}>
          {t('tickets')}
        </a>
        <CButton color={'danger'} onClick={() => logout()}>
          {t('logout')}
        </CButton>
      </div>
    );
  };
  const color = theme === 'theme-dark' ? 'dark' : 'light';
  return (
    <>
      <div
        className={`d-sm-none mt-3 fixed-bottom py-2 border-top bg-${color} text-bg-${color}`}
        style={{ zIndex: 50 }}
      >
        <div className='d-flex justify-content-around'>
          <CButton
            onClick={() => {
              drawer.open(getMenuContent());
            }}
            color={color}
          >
            <CIcon size='xl' icon={cilMenu} />
          </CButton>
          {/* <CButton
            onClick={() => {
              if (appState && typeof appState.openModelsSidebar === 'function') appState.openModelsSidebar();
            }}
            color={color}
          >
            <CIcon size='xl' icon={cilFilter} />
          </CButton> */}

          <CButton
            onClick={() => {
              navigate('tickets');
            }}
            color={color}
          >
            <CIcon size='xl' icon={cilEnvelopeClosed} />
          </CButton>
          <CButton
            onClick={() => {
              drawer.open(getAccountContent());
            }}
            color={color}
          >
            <CIcon size='xl' icon={cilUser} />
          </CButton>
          <CButton
            color={color}
            onClick={() => setTheme((t) => (t == 'theme-dark' ? 'theme-default' : 'theme-dark'))}
          >
            <CIcon
              icon={theme == 'theme-dark' ? cilSun : cilMoon}
              size='xl'
            />
          </CButton>
        </div>
      </div>
    </>
  );
}
